module.exports = __webpack_public_path__ + "img/pic_10.ba65418b.jpg";